import { render, staticRenderFns } from "./LoginScreen.vue?vue&type=template&id=e04cf812&scoped=true&"
import script from "./LoginScreen.vue?vue&type=script&lang=ts&"
export * from "./LoginScreen.vue?vue&type=script&lang=ts&"
import style0 from "./LoginScreen.vue?vue&type=style&index=0&id=e04cf812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04cf812",
  null
  
)

export default component.exports